import utils from '@src/common/utils'

export const energyTableOption = function () {
    return {
        add: '新增',
        edit: '修改',
        view: '查看',
        page: true,
        selection: true,
        index: true,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '100px',
        labelPosition: 'right',
        menuWidth: 200,
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 350,
        dialogWidth: '640px',
        emptyText: '暂无数据',
        menu: false,
        column: [
            {
                label: '预警名称',
                prop: 'earlyWarningName',
                search: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '建筑名称',
                prop: 'buildName',
                search: true,
                searchSlot: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '存储种类',
                prop: 'saveType',
                search: false,
                searchSlot: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
                formatter: function (row, value) {
                    return value === 0 ? '冻鱼' : '冻肉';
                }
            },
            {
                label: '开始周期',
                prop: 'startTime',
                searchSlot: false,
                search: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center'
            },
            {
                label: '结束周期',
                prop: 'endTime',
                search: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '同期能耗',
                prop: 'stThreshold',
                search: false,
                searchSlot: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '预警阈值',
                prop: 'threshold',
                search: false,
                searchSlot: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '创建人',
                prop: 'creator',
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                hide: false,
                align: 'center',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                type: 'datetimerange',
                viewDisplay: false,
                align: 'right',
                hide: false,
                span: 24,
                formatter: function (row, value) {
                    return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
                }
            }
        ],
    }
}
